import { createFormHook, useStore } from "@tanstack/react-form";

import { DateField } from "./date-field";
import { FileUpload } from "./file-upload";
import {
	FormControl,
	FormDescription,
	FormItem,
	FormLabel,
	FormMessage,
	fieldContext,
	formContext,
} from "./form-context";
import { ImageUpload } from "./image-upload";
import { PasswordField } from "./password-field";
import { SubmitButton } from "./submit-button";
import { TextField } from "./text-field";
import { UpdateButton } from "./update-button";

const { useAppForm, withForm } = createFormHook({
	fieldContext,
	formContext,
	fieldComponents: {
		FormLabel,
		FormControl,
		FormDescription,
		FormMessage,
		FormItem,
		FileUpload,
		ImageUpload,
		PasswordField,
		DateField,
		TextField,
	},
	formComponents: {
		SubmitButton,
		UpdateButton,
	},
});

export { useAppForm, useStore, withForm };

export { useFieldContext, useFormContext } from "./form-context";
